export default {"src":"/_next/static/media/create_grops.b8f1e88a.svg","height":284,"width":284};